import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'

import Select from 'components/custom/UserSelection/index'
import UserItem from './UserItem'
import ValueItem from './ValueItem'
import DefaultItem from './DefaultItem'

import styles from './styles.scss'

const placeHolder = <DefaultItem/>

class UserSelection extends Component {
  render() {
    const {
      edit,
      options,
      value,
      onChange,
      onInputChange,
      isLoading
    } = this.props

    return (
      <Select
        clearable={false}
        disabled={!edit}
        isLoading={isLoading}
        labelKey='name'
        multi
        name='user-selection'
        onChange={onChange}
        onInputChange={onInputChange}
        options={options}
        value={value}
        valueKey='username'
      />
    )
  }
}

const withStyle = CSSModules(styles)
export default withStyle(UserSelection)
